import { render, staticRenderFns } from "./ProjectKpis.vue?vue&type=template&id=113e5a4f&"
import script from "./ProjectKpis.vue?vue&type=script&lang=js&"
export * from "./ProjectKpis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports